module.exports = __webpack_public_path__ + "37ba7b92/img/document.e2130c6b.svg";